import { Pipe, PipeTransform } from '@angular/core'

const MX_TIME_ZONE = 'America/Mexico_City'
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/
//* Un periodo `AAAA-MM` (o el primer día de un mes, `AAAA-MM-DD`), como los meses del Buró y de las series.
const MONTH_ONLY = /^(\d{4})-(\d{2})(?:-\d{2})?$/

/**
 * Fechas en español de México y en hora de la Ciudad de México (`1 de octubre de 2026`).
 *
 * ! Una fecha sin hora (`AAAA-MM-DD`) se arma como fecha LOCAL y se formatea sin zona. Con
 * ! `new Date('2026-10-01')` JavaScript la lee como medianoche UTC, que en México es el 30 de
 * ! septiembre: es el día corrido que tiene hoy `ciec-translate.service.ts` · `formatDate`.
 * ! Las fechas con hora sí se convierten a la zona de la Ciudad de México, sea cual sea la del equipo.
 *
 * El modo `month` pinta solo mes y año (`ago 2026`), para los periodos mensuales.
 */
@Pipe({ name: 'mxDate' })
export class MxDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined, mode: 'date' | 'datetime' | 'month' = 'date'): string {
    if (!value) return '—'

    const period = mode === 'month' && typeof value === 'string' ? MONTH_ONLY.exec(value) : null
    if (period) return new Date(Number(period[1]), Number(period[2]) - 1, 1).toLocaleDateString('es-MX', { year: 'numeric', month: 'short' })

    const dateOnly = typeof value === 'string' ? DATE_ONLY.exec(value) : null
    if (dateOnly) {
      const [, year, month, day] = dateOnly
      return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })
    }

    const date = value instanceof Date ? value : new Date(value)
    if (isNaN(date.getTime())) return '—'

    const options: Intl.DateTimeFormatOptions =
      mode === 'month' ? { year: 'numeric', month: 'short', timeZone: MX_TIME_ZONE } : { year: 'numeric', month: 'long', day: 'numeric', timeZone: MX_TIME_ZONE }
    if (mode === 'datetime') Object.assign(options, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
    return date.toLocaleString('es-MX', options)
  }
}
